// src/components/Pages/LivroReclamacoes/LivroReclamacoes.jsx
import { useEffect } from "react";
import { Link } from "react-router-dom";
import Footer from "../Footer/Footer";
import { useI18n } from "../../../i18n/I18nContext";

export default function LivroReclamacoes() {
  const { t } = useI18n();
  return (
    <div className="min-h-screen bg-white flex flex-col">

      <section className="bg-indigo-700 pt-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-10 py-16 text-center">
          <span className="inline-block text-xs font-semibold uppercase tracking-widest text-indigo-200 mb-4 bg-white/10 px-3 py-1 rounded-full">
            {t("Transparência e Qualidade")}
          </span>
          <h1 className="text-3xl sm:text-4xl font-bold text-white mb-4">
            {t("Livro de Reclamações")}
          </h1>
          <p className="text-indigo-100/80 max-w-xl mx-auto text-base">
            {t("Nos termos da lei portuguesa, disponibilizamos o acesso ao Livro de Reclamações Eletrónico.")}
          </p>
        </div>
        <div className="overflow-hidden leading-none">
          <svg viewBox="0 0 1440 60" className="w-full" preserveAspectRatio="none" style={{ height: 60 }}>
            <path d="M0,40 C360,80 1080,0 1440,40 L1440,60 L0,60 Z" fill="white" />
          </svg>
        </div>
      </section>

      <section className="flex-1 py-20 bg-white">
        <div className="max-w-2xl mx-auto px-4 sm:px-6 text-center">

          <h2 className="text-xl font-bold text-gray-900 mb-3">
            {t("Tem uma reclamação a apresentar?")}
          </h2>
          <p className="text-gray-500 text-sm sm:text-base mb-8 max-w-lg mx-auto">
            {t("O Livro de Reclamações Eletrónico é disponibilizado pelo Portal do Consumidor, em cumprimento do Decreto-Lei n.º 74/2017, de 21 de junho. Clique no botão abaixo para aceder diretamente.")}
          </p>

          <a
            href="https://www.livroreclamacoes.pt/Inicio/"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 px-8 py-4 rounded-xl bg-red-600 text-white font-semibold text-base hover:bg-red-700 shadow-md transition-all"
          >
            <svg className="w-5 h-5" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" d="M13.5 6H5.25A2.25 2.25 0 003 8.25v10.5A2.25 2.25 0 005.25 21h10.5A2.25 2.25 0 0018 18.75V10.5m-10.5 6L21 3m0 0h-5.25M21 3v5.25" />
            </svg>
            {t("Aceder ao Livro de Reclamações")}
          </a>

          <p className="mt-6 text-xs text-gray-400">
            {t("Será redirecionado para")} <span className="font-medium">livroreclamacoes.pt</span>, {t("plataforma oficial gerida pela Direção-Geral do Consumidor.")}
          </p>

          <div className="mt-12 rounded-2xl border border-gray-200 bg-gray-50 shadow-md p-6 text-left">
            <h3 className="font-semibold text-gray-900 mb-3 text-sm uppercase tracking-wide">{t("Antes de reclamar")}</h3>
            <ul className="space-y-2 text-sm text-gray-600">
              <li className="flex items-start gap-2">
                <span className="text-indigo-500 mt-0.5">→</span>
                {t("Tente primeiro contactar-nos diretamente pelo email")} <a href="mailto:clients@racksforall.eu" className="text-indigo-600 hover:underline">clients@racksforall.eu</a>
              </li>
              <li className="flex items-start gap-2">
                <span className="text-indigo-500 mt-0.5">→</span>
                {t("Ou ligue-nos para")} <a href="tel:+351 91 365 07 24" className="text-indigo-600 hover:underline">+351 91 365 07 24</a> ({t("Segunda a Sexta, 9h–18h")})
              </li>
              <li className="flex items-start gap-2">
                <span className="text-indigo-500 mt-0.5">→</span>
                {t("Comprometemo-nos a responder em até 48 horas úteis.")}
              </li>
            </ul>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}